var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"secao-vazia"},[_c('b-icon',{staticClass:"icone-aviso mb-2",attrs:{"icon":"exclamation-triangle","font-scale":"7.5"}}),_c('p',[_vm._v("Nenhum chamado encontrado!")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }